import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, PHONE_1, PHONE_1_TEL, scrollToId } from "@/data/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-[60] transition-colors duration-500 ${
        scrolled ? "bg-espresso/95 backdrop-blur-md border-b gold-hairline" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button onClick={() => go("home")} data-testid="nav-logo" className="text-left leading-none">
          <span className="font-serif text-2xl md:text-3xl tracking-[0.18em] text-cream">MOMAY</span>
          <span className="block text-[9px] md:text-[10px] tracking-[0.5em] text-gold mt-1">CATERERS</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm tracking-[0.2em] uppercase text-cream/80 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("quote")}
            className="border border-gold text-gold px-6 py-2.5 text-xs tracking-[0.25em] uppercase hover:bg-gold hover:text-espresso transition-colors duration-300"
          >
            Get a Quote
          </button>
        </nav>

        <div className="flex items-center gap-4 md:hidden">
          <a href={`tel:${PHONE_1_TEL}`} data-testid="nav-call-mobile" aria-label={`Call ${PHONE_1}`} className="text-gold">
            <Phone size={20} />
          </a>
          <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} aria-label="Menu" className="text-cream">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-espresso border-t gold-hairline overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left text-cream/90 tracking-[0.2em] uppercase text-sm"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-quote-btn"
                onClick={() => go("quote")}
                className="mt-2 border border-gold text-gold px-6 py-3 text-xs tracking-[0.25em] uppercase"
              >
                Get a Quote
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
